import { defineComponent, reactive, provide, onMounted, onUnmounted, createVNode } from "vue";
import responsiveObserve, { responsiveArray } from "../_utils/responsive-observe.js";
import { getPrefixCls } from "../_utils/global-config.js";
var _GridRow = defineComponent({
  name: "Row",
  props: {
    gutter: {
      type: [Number, Object, Array],
      default: 0
    },
    justify: {
      type: String,
      validator: (value) => {
        return ["start", "center", "end", "space-around", "space-between"].includes(value);
      },
      default: "start"
    },
    align: {
      type: String,
      validator: (value) => {
        return ["start", "center", "end", "stretch"].includes(value);
      },
      default: "start"
    },
    div: {
      type: Boolean
    }
  },
  setup(props, {
    slots
  }) {
    const prefixCls = getPrefixCls("row");
    const rowContext = reactive({
      gutter: void 0,
      div: void 0
    });
    provide("rowContext", rowContext);
    const state = reactive({
      screens: {
        xs: true,
        sm: true,
        md: true,
        lg: true,
        xl: true,
        xxl: true
      }
    });
    let token;
    onMounted(() => {
      token = responsiveObserve.subscribe((screens) => {
        const {
          gutter
        } = props;
        if (!Array.isArray(gutter) && typeof gutter === "object" || Array.isArray(gutter) && (typeof gutter[0] === "object" || typeof gutter[1] === "object")) {
          state.screens = screens;
        }
      });
    });
    onUnmounted(() => {
      responsiveObserve.unsubscribe(token);
    });
    const getGutter = (gutter) => {
      const {
        screens
      } = state;
      let result = 0;
      if (typeof gutter === "object") {
        for (let i = 0; i < responsiveArray.length; i++) {
          const breakpoint = responsiveArray[i];
          if (screens[breakpoint] && gutter[breakpoint] !== void 0) {
            result = gutter[breakpoint];
            break;
          }
        }
      } else {
        result = gutter;
      }
      return result;
    };
    return () => {
      var _a;
      const {
        gutter,
        align,
        justify,
        div
      } = props;
      const classNames = {
        [`${prefixCls}`]: !div,
        [`${prefixCls}-align-${align}`]: align,
        [`${prefixCls}-justify-${justify}`]: justify
      };
      const styles = {};
      const gutterHorizontal = getGutter(Array.isArray(gutter) ? gutter[0] : gutter);
      const gutterVertical = getGutter(Array.isArray(gutter) ? gutter[1] : 0);
      if ((gutterHorizontal || gutterVertical) && !div) {
        const marginHorizontal = -gutterHorizontal / 2;
        const marginVertical = -gutterVertical / 2;
        if (marginHorizontal) {
          styles.marginLeft = `${marginHorizontal}px`;
          styles.marginRight = `${marginHorizontal}px`;
        }
        if (marginVertical) {
          styles.marginTop = `${marginVertical}px`;
          styles.marginBottom = `${marginVertical}px`;
        }
      }
      rowContext.gutter = [gutterHorizontal, gutterVertical];
      rowContext.div = div;
      return createVNode("div", {
        "class": classNames,
        "style": styles
      }, [(_a = slots.default) == null ? void 0 : _a.call(slots)]);
    };
  }
});
export { _GridRow as default };
